import { camelizeKeys } from 'humps';
import { getAsJson, validateScheme } from '@namespace/helpers';
import { appleSessionResponseShema } from './shemas';
import { AppleSessionResponse } from './types';

export const getAppleSession = () =>
  getAsJson<{ response: AppleSessionResponse }>(
    `/accounting/api/v1/payments/apple-session`
  ).then(({ response }) => {
    validateScheme(appleSessionResponseShema, response, {
      name: 'getPayments'
    });

    return camelizeKeys<AppleSessionResponse>(response);
  });
